export default __webpack_public_path__ + "static/media/G0006.c3b02647.png";